import axios from 'axios'

import locale from '../services/locale'

const call = {
    get: (url, data = {}) => {
        return axios({
            method: 'GET',
            url:
                process.env.REACT_APP_ENDPOINT +
                url +
                '?' +
                Object.entries(data)
                    .map(([key, val]) => `${key}=${val}`)
                    .join('&'),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Locale: locale.get(),
                Authorization: `Bearer ${window.localStorage.getItem('token') || ''}`,
            },
            data: {},
        })
    },
    post: (url, data = {}) => {
        return axios({
            method: 'POST',
            url: process.env.REACT_APP_ENDPOINT + url,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Locale: locale.get(),
                Authorization: `Bearer ${window.localStorage.getItem('token') || ''}`,
            },
            data,
        })
    },
}

const api = {
    structure: () => {
        return call.get('/v2/structure', {})
    },
    article: (id) => {
        return call.get(`/v2/article/${id}`, {})
    },
    signup: (email, name, position, cycle, coupon) => {
        return call.post('/v3/signup', { email, name, position, cycle, coupon })
    },
    confirm: (id, token, code) => {
        return call.post('/v3/confirm', { id, token, code })
    },
    access: (email) => {
        return call.post('/v3/access', { email })
    },
    code: (email, token, code) => {
        return call.post('/v3/code', { email, token, code })
    },
    launch: (code) => {
        return call.post('/v2/launch', { code })
    },
    payment: (id) => {
        return call.get(`/v2/payment/${id}`)
    },
    account: () => {
        return call.get(`/v3/account`)
    },
    terminate: (feedback) => {
        return call.post(`/v3/terminate`, { feedback })
    },
}

export default api
